// ACCOUNT NEGATIVE CONSUMPTION LIMIT *************************************************************
// pathname: /v1/user/account-negative-consumption-limit
// ************************************************************************************************
import { ApiAccountNegativeConsumptionLimitOk } from '@type/v1-api-types';
import { isAccountNegativeConsumptionLimitOk } from 'src/type-predicates/v1-api-predicates';
import { useSwrApi } from '../../useSwrApi';

/**
 * @description This hook is used for getting the user's account negative consumption limit.
 * - `locale` is the language locale
 * - `shouldFetch` is a boolean indicating whether the request should be made
 */
export const useSwrAccountNegativeConsumptionLimit = (locale: string, shouldFetch = true) => {
  // SWR: fetch data
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiAccountNegativeConsumptionLimitOk>({
    url: '/v1/user/account-negative-consumption-limit',
    locale,
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
    },
  });

  // Return data
  return {
    negativeConsumptionLimitData: isAccountNegativeConsumptionLimitOk(data) ? data : undefined,
    negativeConsumptionLimitError: error,
    negativeConsumptionLimitLoading: isLoading,
    negativeConsumptionLimitValidating: isValidating,
    mutateNegativeConsumptionLimit: mutate,
  };
};
